import {incomePlanAxios} from "@/axios";

export const netWorthSummary =  {

    namespaced: true,

    state: {
        totals: {}
    },

    actions: {
        summary ({ commit }, { householdId }) {
            incomePlanAxios.get(`api/households/${householdId}/net-worth-summary`).then(function (response) {
                commit('setSummaryData', {data: response.data.data});
            });
        }
    },

    mutations: {
        setSummaryData (state, { data }) {
            state.totals  = data.totals;
        }
    }
}
